import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addAudioOrder, deleteAudioOrder, getOrderAudios } from "./orderApi";
import { selectAudios, selectOrder, setAudios } from "./orderSlice";
import './orderAudio.css'
import AudioRec from "../../Common/AudioRec";
import { texts, url } from "../../Common/common";
import { selectLanguage, selectRole } from "../../Login/loginSlice";

export default function OrderAudio() {
    const dispatch = useDispatch();
    const role = useSelector(selectRole);
    const currentLanguage = useSelector(selectLanguage);
    const audios = useSelector(selectAudios);
    const order = useSelector(selectOrder);

    const [playingAudio, setPlayingAudio] = useState(-1);
    const [playing, setPlaying] = useState(false);
    const [audioInstance, setAudioInstance] = useState(null);

    const handleGetOrderAudio = () => {
        getOrderAudios({ order_id: order.id }, (data) => {
            console.log('getOrderAudios', data)
            if (data.res) dispatch(setAudios(data.audios));
        });
    };

    const handleSaveAudio = (uri) => {
        addAudioOrder({ audio: uri, order_id: order.id }, () => {
            handleGetOrderAudio();
        });
    };

    const handlePlayAudio = (uri, i) => {
        if (playingAudio === i) {
            audioInstance?.pause();
            setPlaying(false);
            setPlayingAudio(-1);
            return;
        }

        if (audioInstance) {
            audioInstance.pause();
        }

        const audio = new Audio(`${url}/static/uploads/${uri}`);
        audio.play();
        setAudioInstance(audio);
        setPlaying(true);
        setPlayingAudio(i);

        audio.onended = () => {
            setPlaying(false);
            setPlayingAudio(-1);
        };
    };

    const handleAudioPress = (audio, i) => {
        const audioUrl = `${url}/static/uploads/${audio.url_audio}`;
        if (!window.confirm("Выберите действие: OK = воспроизвести, Отмена = удалить")) return;

        // Для web можно заменить на модальные окна или контекстное меню
        const action = window.prompt("Введите: play / delete / copy");
        if (action === "play") handlePlayAudio(audio.url_audio, i);
        if (action === "delete") {
            deleteAudioOrder({ audio_id: audio.id, order_id: order.id }, (data) => {
                if (data.res) {
                    handleGetOrderAudio();
                    alert("Аудио удалено");
                } else {
                    alert(data.message || "Ошибка при удалении аудио");
                }
            });
        }
        if (action === "copy") {
            navigator.clipboard.writeText(audioUrl);
            alert("Ссылка скопирована");
        }
    };

    return (
        <div className="order-part-3">
            <div className="audio-header">
                <span>{texts[currentLanguage].audio}</span>
                {role !== "doctor" && <AudioRec handleSaveAudio={handleSaveAudio} />}
            </div>

            <div className="audio-list" style={{ maxHeight: 150, overflowY: "auto" }}>
                {audios.length === 0 ? (
                    <p>Аудио отсутствует</p>
                ) : (
                    // audios.map((audio, i) => (
                    //     <div
                    //         key={i}
                    //         className="audio-item"
                    //         onClick={() => handleAudioPress(audio, i)}
                    //         style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                    //     >
                    //         <span style={{ flex: 5 }}>AUDIO {i}</span>
                    //         <button
                    //             style={{ flex: 1 }}
                    //             onClick={(e) => {
                    //                 e.stopPropagation();
                    //                 handlePlayAudio(audio.url_audio, i);
                    //             }}
                    //         >
                    //             {playingAudio === i ? "🔊" : "▶️"}
                    //         </button>
                    //     </div>
                    // ))

                    audios.map((audio, i) => (
                        <div
                            key={i}
                            className="audio-item"
                            onClick={() => handleAudioPress(audio, i)}
                            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                        >
                            <span style={{ flex: 5 }}>AUDIO {i}</span>

                            {/* Кнопка для воспроизведения */}
                            <div style={{ flex: 1 }}>
                                {playingAudio === i ? (
                                    // Если играет, показываем элемент audio с автоплей
                                    <audio
                                        src={`${url}/static/uploads/${audio.url_audio}`}
                                        controls
                                        autoPlay
                                        onEnded={() => setPlayingAudio(-1)}
                                        style={{ width: '100%' }}
                                    />
                                ) : (
                                    <button
                                        style={{ width: '100%' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPlayingAudio(i); // показывает <audio> с автоплеем
                                        }}
                                    >
                                        ▶️
                                    </button>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
